import { GetRemittanceDetailsType } from '../../../../types/Invoicing/RemittanceDetails/remittanceDetailstype'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, invoicelocationListApiConfig } from '../../apiList'

const getRemittanceDetails = async (): Promise<GetRemittanceDetailsType> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: invoicelocationListApiConfig.getRemittanceList,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const addInvoiceLocation = async (name: string): Promise<string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: invoicelocationListApiConfig.getLocationList,
    method: AllowedHttpMethods.post,
    data: {
      name,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const deleteInvoiceLocation = async (
  locationId: number,
): Promise<GetRemittanceDetailsType> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: invoicelocationListApiConfig.deleteLocationList,
    method: AllowedHttpMethods.delete,
    params: {
      locationId,
    },
    data: {
      locationId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const invoiceslocationlistApi = {
  getRemittanceDetails,
  addInvoiceLocation,
  deleteInvoiceLocation,
}

export default invoiceslocationlistApi
